import _ from '../../utils/underscore';
import {GEO_LOCATION, GEO_LOCATION_REASONS} from './geo_consts';
import {IGeoRequestParams} from "./geo_service_interface";

export default class GeoDataFormatter {
    static CLASS = 'GeoDataFormatter';
    private _userId: string = '';
    private _reason: string = '';
    private _phone: string = '';
    private _license: string = '';
    private _sessionKey: string = '';
    private _dataOk:number = 0;
    private _bMandatory:boolean = false;
    private _isRetryFlow: boolean = false;

    constructor (data:IGeoRequestParams, userID:string, bMandatory:boolean, reason:string) {
        if( _.isNullOrUndefined(data)){
            return;
        }

        this._setPhone(data.mobileNumber);
        this._setLicense(data.licenseKey);
        this._setSessionKey(data.locationTransactionId);
        this._setIsRetryFlow(data.isRetryFlow);
        this._setUserId(userID);
        this._setMandatory(bMandatory);
        this._setReason(reason);
    }

    get isMandatory(): boolean {
        return this._bMandatory;
    }

    get isRetryFlow(): boolean {
        return this._isRetryFlow;
    }

    get userId(): string{
        return this._userId;
    }
    get reason(): string {
        return this._reason;
    }
    get phone(): string{
        return this._phone;
    }
    get license(): string{
        return this._license;
    }
    get sessionKey(): string{
        return this._sessionKey;
    }

    get isPeriodic(): boolean{
        return GEO_LOCATION_REASONS.REASON_PERIODIC === this._reason;
    }

    private _setMandatory(b:boolean):void {
        this._bMandatory = b
    }

    private _setIsRetryFlow(val:boolean):void {
        if(_.isNullOrUndefined(val)) {
            this._isRetryFlow = false;
        } else {
            this._isRetryFlow = val;
        }
    }

    private _setUserId(val):void{
        this._userId = this._setKey(val, GEO_LOCATION.USER_ID_OK);
    }

    private _setReason(val):void {
        this._reason = this._setKey(val, GEO_LOCATION.REASON_OK);
    }

    private _setPhone(val):void{
        if(this._isValid(val)) {
            this._phone = this._setKey(val, GEO_LOCATION.PHONE_OK);
        }
    }

    private _setLicense(val):void{
        if(this._isValid(val)) {
            this._license = this._setKey(val, GEO_LOCATION.LICENSE_OK);
        }
    }

    private _setSessionKey(val):void{
        if(this._isValid(val)) {
            this._sessionKey = this._setKey(val, GEO_LOCATION.SESSION_KEY_OK);
        }
    }

    private _setKey(val:string, datakey:number):string {
        this._dataOk |= datakey;
        return val;
    }

    private _isValid (val:string):boolean {
        return !_.isEmpty(val);
    }

    public isDataValid() {
        return (GEO_LOCATION.ALL_DATA_OK === this._dataOk);
    }

    public getAllData() {
        let data = null;
        if(this.isDataValid()) {
             data = {
                 [GEO_LOCATION.USER_ID]: this._userId,
                 [GEO_LOCATION.REASON]: this._reason,
                 [GEO_LOCATION.PHONE]: this._phone,
                 [GEO_LOCATION.LICENSE]: this._license,
                 [GEO_LOCATION.SESSION_KEY]: this._sessionKey
             };
        }
        return data;
    }
}